import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Logo } from "../components/Logo";
import { IMG_AUTH_BG } from "../lib/images";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-80px)] grid grid-cols-1 lg:grid-cols-2" data-testid="forgot-password-page">
      <div className="hidden lg:block relative">
        <img src={IMG_AUTH_BG} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-midnight-black/50" />
      </div>
      <div className="flex items-center justify-center px-6 py-16 bg-clean-white">
        <div className="w-full max-w-sm">
          <div className="bg-midnight-black rounded-xl px-4 py-3 inline-block mb-10">
            <Logo className="h-9" />
          </div>
          <h1 className="font-extrabold uppercase text-2xl tracking-tight mb-2">Forgot Password</h1>
          <p className="text-midnight-black/60 font-medium mb-8 text-sm">Enter your email and we'll send you a reset link.</p>
          {sent ? (
            <p className="text-sm font-bold text-midnight-black/80" data-testid="forgot-password-sent-message">
              If an account exists for that email, a reset link has been sent. Check your inbox.
            </p>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4" data-testid="forgot-password-form">
              <Input data-testid="forgot-password-email-input" type="email" placeholder="Email" required value={email} onChange={(e) => setEmail(e.target.value)} />
              {error && (
                <p className="text-sm font-bold text-red-600" data-testid="forgot-password-error">
                  {error}
                </p>
              )}
              <Button type="submit" data-testid="forgot-password-submit-button" disabled={loading} className="w-full bg-stranger-orange hover:bg-orange-600 text-clean-white font-bold tracking-wide rounded-full py-6">
                {loading ? "Sending..." : "SEND RESET LINK"}
              </Button>
            </form>
          )}
          <p className="text-sm font-medium text-midnight-black/60 mt-6">
            <Link to="/login" data-testid="back-to-login-link" className="text-stranger-orange font-bold hover:underline">
              Back to log in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
